import { EnvironmentService } from '../environment-service/environment.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../environment-service/environment.service";
var FeatureFlagService = /** @class */ (function () {
    function FeatureFlagService(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
    }
    FeatureFlagService.prototype.getFeatureFlagStateSummary = function () {
        var url = this.environmentService.getApiRoot() + 'feature-flag-state/summary';
        return this.http.get(url);
    };
    FeatureFlagService.prototype.getFeatureFlagStateDetails = function () {
        var url = this.environmentService.getApiRoot() + 'feature-flag-state/details';
        return this.http.get(url);
    };
    FeatureFlagService.ngInjectableDef = i0.defineInjectable({ factory: function FeatureFlagService_Factory() { return new FeatureFlagService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService)); }, token: FeatureFlagService, providedIn: "root" });
    return FeatureFlagService;
}());
export { FeatureFlagService };
